export class ValidationError extends Error {
  constructor(message: string, private readonly reasons: Array<string>, private readonly requestData?: {[key: string]: unknown}) {
    super(message);
    // Set the name correctly to the class name
    this.name = this.constructor.name;
  }

  getReasons(): string[]{
    return this.reasons;
  }

  getValidationErrorResponse(){
    return {
      validationErrors: this.reasons
    }
  }

  getRequestData(): {[key: string]: unknown} | unknown {
    return this.requestData
  }
}

export class AuthorizationError extends Error {
  constructor(message: string) {
    super(message);
    // Set the name correctly to the class name
    this.name = this.constructor.name;
  }
}

export class AuthenticationError extends Error {
  constructor(message: string) {
    super(message);
    // Set the name correctly to the class name
    this.name = this.constructor.name;
  }
}

export class NetworkError extends Error {
  constructor(message: string) {
    super(message);
    // Set the name correctly to the class name
    this.name = this.constructor.name;
  }
}

export class EntityNotFoundError extends Error {
  constructor(message: string, private readonly requestData?: {[key: string]: unknown}) {
    super(message);
    // Set the name correctly to the class name
    this.name = this.constructor.name;
  }

  getRequestData(): {[key: string]: unknown} | undefined {
    return this.requestData
  }
}